import "./Project1.css";

function Project5() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>Trafalgar st James</h2>
      </div>
      <div className="about-text">
        <p>
        Trafalgar st James is an innovative custom theme with various custom blocks developed for a travel and hospitality management company. The website has a sleek and user-friendly interface, providing potential clients with an immersive visual experience. The project was implemented using PHP, ACF, CSS, SASS, WordPress, JavaScript, and jQuery.
      <br/>
      Trafalgar st James was developed under the expert supervision and creative direction of Up Hotel Agency.
        </p>
        <h3 className="project-link">
          <a
            href="https://trafalgarstjames.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project5;
